import { getAuthAxiosBackend } from "@/helpers/axios"
import { SacrificerServices } from "@/services/sacrificerServices"

class MartyrServices extends SacrificerServices{    

    getProfileDataByPersonId(id){
        return getAuthAxiosBackend().get('PersonProfile/martyrProfile/' + id.toString())
    }
}

export default new MartyrServices()